import { render, staticRenderFns } from "./GraficoFaixaDeIdade.vue?vue&type=template&id=fa195556&scoped=true"
import script from "./GraficoFaixaDeIdade.vue?vue&type=script&lang=js"
export * from "./GraficoFaixaDeIdade.vue?vue&type=script&lang=js"
import style0 from "./GraficoFaixaDeIdade.vue?vue&type=style&index=0&id=fa195556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa195556",
  null
  
)

export default component.exports